<template>
  <nav class="tw-border-t tw-border-gray-150 tw-px-0 tw-flex tw-items-center tw-justify-between">
    <div>
      <base-select :options="rowOptions" :value="value.take" @input="updateTake" />
    </div>
    <div class="tw-flex tw-items-center tw-flex-grow tw-justify-end tw--mt-2.5 md:tw--mt-2.5">
      <div class="tw-flex tw-flex-shrink-0">
        <button
          class="tw--mt-px tw-border-t-2 tw-border-transparent tw-pt-3.5 sm:tw-pt-2.5 md:tw-pt-3 tw-pr-1 tw-inline-flex tw-items-center tw-text-sm tw-leading-5 tw-font-normal tw-text-gray-500 hover:tw-text-gray-700 hover:tw-border-gray-300 focus:tw-outline-none focus:tw-text-gray-700 focus:tw-border-gray-400 tw-transition tw-ease-in-out tw-duration-150"
          @click="goToPrevious"
        >
          <arrow-left-icon class="tw-h-4 tw-w-4 tw-mr-1.5" />Previous
        </button>
      </div>
      <div class="tw-hidden md:tw-flex">
        <base-pagination-tab v-for="page in leftPages" :key="`left-${page}`" @click="updatePage(page)" :is-selected="page === currentPage">{{ page }}</base-pagination-tab>
        <div class="tw-flex" v-if="exceededMax">
          <div class="tw-text-gray-500 tw-pt-3">...</div>
          <div class="tw-flex" v-if="showMiddlePages">
            <base-pagination-tab v-for="page in middlePages" :key="`middle-${page}`" @click="updatePage(page)" :is-selected="page === currentPage">{{ page }}</base-pagination-tab>
          </div>
          <div class="tw-text-gray-500 tw-pt-3" v-if="showMiddlePages">...</div>
          <base-pagination-tab v-for="page in rightPages" :key="`right-${page}`" @click="updatePage(page)" :is-selected="page === currentPage">{{ page }}</base-pagination-tab>
        </div>
      </div>
      <div class="tw-flex tw-justify-end">
        <button
          class="tw--mt-px tw-border-t-2 tw-border-transparent tw-pt-3.5 sm:tw-pt-2.5 md:tw-pt-3 tw-pl-1 tw-inline-flex tw-items-center tw-text-sm tw-leading-5 tw-font-normal tw-text-gray-500 hover:tw-text-gray-700 hover:tw-border-gray-300 focus:tw-outline-none focus:tw-text-gray-700 focus:tw-border-gray-400 tw-transition tw-ease-in-out tw-duration-150"
          @click="goToNext"
        >
          Next
          <arrow-right-icon class="tw-h-4 tw-w-4 tw-ml-1.5" />
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import BasePaginationTab from "@/components/base/BasePaginationTab";
import BaseSelect from "@/components/base/BaseSelect";
import { ArrowLeftIcon, ArrowRightIcon } from "@/assets/svgs";
const MAX_TABS = 10;
export default {
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
    BasePaginationTab,
    BaseSelect,
  },
  props: {
    value: Object,
  },
  data() {
    return {};
  },
  computed: {
    rowOptions() {
      var options = [10, 20, 50, 100];
      if (options.includes(+this.value.take)) return [{ value: 10, label: 10 }, { value: 20, label: 20 }, { value: 50, label: 50 }, { value: 100, label: 100 }];
      else
        return [{ value: this.value.take, label: this.value.take }, { value: 10, label: 10 }, { value: 20, label: 20 }, { value: 50, label: 50 }, { value: 100, label: 100 }].sort(
          (a, b) => a.value - b.value,
        );
    },
    exceededMax() {
      return this.totalPages >= MAX_TABS;
    },
    leftPages() {
      if (!this.exceededMax) {
        return this.totalPages;
      }
      if (this.currentPage > 3) {
        return 1;
      }
      if (this.currentPage === 3) {
        return 4;
      }
      return 3;
    },
    showMiddlePages() {
      return this.currentPage > 3 && this.currentPage < this.totalPages - 2;
    },
    middlePages() {
      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    },
    rightPages() {
      if (this.currentPage < this.totalPages - 2) {
        return [this.totalPages];
      }
      if (this.currentPage === this.totalPages - 2) {
        return [this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages];
      }
      return [this.totalPages - 2, this.totalPages - 1, this.totalPages];
    },
    totalPages() {
      return +Math.ceil(this.value.total / this.value.take);
    },
    currentPage() {
      return Math.floor(this.value.skip / this.value.take) + 1;
    },
  },
  methods: {
    updatePage(page) {
      if (this.currentPage !== page) {
        this.$emit("input", {
          ...this.value,
          skip: this.value.take * (page - 1),
        });
      }
    },
    goToPrevious() {
      if (this.currentPage !== 1) {
        this.$emit("input", {
          ...this.value,
          skip: this.value.skip - this.value.take,
        });
      }
    },
    goToNext() {
      if (this.currentPage !== this.totalPages) {
        this.$emit("input", {
          ...this.value,
          skip: this.value.skip + this.value.take,
        });
      }
    },
    updateTake(take) {
      this.$emit("input", {
        ...this.value,
        skip: Math.floor(this.value.skip / take) * take,
        take: +take,
      });
    },
  },
};
</script>
